import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { Button, InputNumber } from 'antd';
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { toInt } from "../../../../swzutils/TypeUtils";
const NumberMinMaxTableFilter = ({ defaultMin = null, defaultMax = null, onApplyFilter, onClearFilter }) => {
    const [min, setMin] = useState((defaultMin && defaultMin.length > 0) ? toInt(defaultMin[0], null) : null);
    const [max, setMax] = useState((defaultMax && defaultMax.length > 0) ? toInt(defaultMax[0], null) : null);
    const maxInputRef = useRef(null);
    const applyFilterClicked = () => {
        onApplyFilter(min ? [min] : null, max ? [max] : null);
    };
    const clearFilterClicked = () => {
        setMin(null);
        setMax(null);
        onClearFilter();
    };
    return (_jsxs("div", { className: "custom-filter-dropdown", children: [_jsx(InputNumber, { placeholder: "Min", style: { width: "70px" }, value: min, onChange: setMin, onPressEnter: () => maxInputRef.current?.focus() }), "\u00A0-\u00A0", _jsx(InputNumber, { ref: maxInputRef, placeholder: "Max", style: { width: "70px" }, value: max, onChange: setMax, onPressEnter: applyFilterClicked }), "\u00A0", _jsx(Button, { type: "primary", onClick: applyFilterClicked, children: _jsx(SearchOutlined, {}) }), "\u00A0", _jsx(Button, { type: "default", onClick: clearFilterClicked, children: _jsx(CloseOutlined, {}) })] }));
};
export default NumberMinMaxTableFilter;
